import {Injectable} from '@angular/core';
import {LabelExpressionUtilityService} from '../label-expression-utility-service';
import {LabelExpressionBuildService} from './label-expression-build.service';
import {labelProperties, Attributes, SubTypeMap} from '../../../../common/models/label-expression.model';

@Injectable({
    providedIn: 'root'
})
export class GeneralAnnotationLabelExpressionBuilderService {
    title = 'GeneralAnnotationLabelExpressionBuilder';
    subTypeMap: SubTypeMap = [];

    constructor(
        private labelExpressionBuildService: LabelExpressionBuildService,
        private labelExpressionUtilityService: LabelExpressionUtilityService
    ) {
        this.init();
    }

    init() {
        this.subTypeMap[1] = {function: this.buildNotation10.bind(this)}; // Notation
        this.subTypeMap[2] = {function: this.buildDepthLimitAll.bind(this)};
        this.subTypeMap[3] = {function: this.buildNotation7.bind(this)}; // Survey Sheet Notation
        this.subTypeMap[4] = {function: this.buildNotation7.bind(this)}; // Control Network Notation
        this.subTypeMap[5] = {function: this.buildAbuttalAnnotationLot.bind(this)}; // Lot
        this.subTypeMap[6] = {function: this.buildAbuttalAnnotationLot.bind(this)}; // Strata Lot
        this.subTypeMap[7] = {function: this.buildAbuttalAnnotationRoadsAndHighWays.bind(this)};
        this.subTypeMap[8] = {function: this.buildAbuttalAnnotationAccessWay.bind(this)}; // Right Of Way
        this.subTypeMap[9] = {function: this.buildAbuttalAnnotationReserves.bind(this)};
        this.subTypeMap[10] = {function: this.buildAbuttalAnnotationPastralLease.bind(this)};
        this.subTypeMap[11] = {function: this.buildSingleAbuttalAnnotation14.bind(this)}; // UCL
        this.subTypeMap[12] = {function: this.buildAbuttalAnnotationMiningTenement.bind(this)};
        this.subTypeMap[13] = {function: this.buildAbuttalAnnotationStateForest.bind(this)};
        this.subTypeMap[14] = {function: this.buildSingleAbuttalAnnotation14.bind(this)}; // Townsite
        this.subTypeMap[15] = {function: this.buildAbuttalAnnotationWater.bind(this)};
        this.subTypeMap[16] = {function: this.buildSingleAbuttalAnnotation10.bind(this)}; // PlanNumber
        this.subTypeMap[17] = {function: this.buildSingleAbuttalAnnotation10.bind(this)}; // Title Reference
        this.subTypeMap[18] = {function: this.buildSingleAbuttalAnnotation14.bind(this)}; // Closed Road
        this.subTypeMap[19] = {function: this.buildAbuttalAnnotationAccessWay.bind(this)}; // Pedestrian Access Way
        this.subTypeMap[20] = {function: this.buildOccupationImprovement.bind(this)};
        this.subTypeMap[21] = {function: this.buildSingleAbuttalAnnotation14.bind(this)}; // Unnamed Road
        this.subTypeMap[22] = {function: this.buildAbuttalOtherReserve.bind(this)}; // Railway Reserve
        this.subTypeMap[23] = {function: this.buildAbuttalOtherReserve.bind(this)}; // Drain Reserve
        this.subTypeMap[24] = {function: this.buildDepthLimitOther.bind(this)}; // Depth Limit Lots
        this.subTypeMap[25] = {function: this.buildDepthLimitOther.bind(this)}; // Depth Limit Location
    }

    build(attributes: Attributes) {
        return this.labelExpressionBuildService.build(this.title, this.subTypeMap, attributes);
    }

    formatLabel(value: string, size: number, normal: boolean) {
        return this.labelExpressionUtilityService.formatLabel(value, size, normal);
    }

    getLabelProperties(fontSize: string, fontStyle: string, textAnchor: string, attributes: string) {
        return this.labelExpressionUtilityService.getLabelProperties(fontSize, fontStyle, textAnchor, attributes);
    }

    buildNotation7(attributes: Attributes) {
        let attribute1 = '';
        let attribute2 = '';
        let attribute3 = '';
        let attribute4 = '';
        let attribute5 = '';
        const labels = [];
        const labelProperties = {} as labelProperties;
        let labelValue = '';

        if (attributes.attribute1) {
            attribute1 = attributes.attribute1.toUpperCase() + '\n';
            labels.push(this.getLabelProperties('7.2em', 'normal', 'middle', attributes.attribute1.toUpperCase()));
        }

        if (attributes.attribute2) {
            attribute2 = attributes.attribute2.toUpperCase() + '\n';
            labels.push(this.getLabelProperties('7.2em', 'normal', 'middle', attributes.attribute2.toUpperCase()));
        }

        if (attributes.attribute3) {
            attribute3 = attributes.attribute3.toUpperCase() + '\n';
            labels.push(this.getLabelProperties('7.2em', 'normal', 'middle', attributes.attribute3.toUpperCase()));
        }

        if (attributes.attribute4) {
            attribute4 = attributes.attribute4.toUpperCase() + '\n';
            labels.push(this.getLabelProperties('7.2em', 'normal', 'middle', attributes.attribute4.toUpperCase()));
        }

        if (attributes.attribute5) {
            attribute5 = attributes.attribute5.toUpperCase();
            labels.push(this.getLabelProperties('7.2em', 'normal', 'middle', attributes.attribute5.toUpperCase()));
        }

        labelValue = (attribute1 + attribute2 + attribute3 + attribute4 + attribute5).replace(new RegExp('\n$'), '');
        if (labelValue !== '') {
            labelProperties.labels = labels;
            labelProperties.labelExpression = this.formatLabel(labelValue, 7.2, true);

            return labelProperties;
        } else {
            return null;
        }
    }

    buildNotation10(attributes: Attributes) {
        let attribute1 = '';
        let attribute2 = '';
        let attribute3 = '';
        let attribute4 = '';
        let attribute5 = '';
        const labels = [];
        const labelProperties = {} as labelProperties;
        let labelValue = '';

        if (attributes.attribute1) {
            attribute1 = attributes.attribute1.toUpperCase() + '\n';
            labels.push(this.getLabelProperties('10em', 'normal', 'middle', attributes.attribute1.toUpperCase()));
        }

        if (attributes.attribute2) {
            attribute2 = attributes.attribute2.toUpperCase() + '\n';
            labels.push(this.getLabelProperties('10em', 'normal', 'middle', attributes.attribute2.toUpperCase()));
        }

        if (attributes.attribute3) {
            attribute3 = attributes.attribute3.toUpperCase() + '\n';
            labels.push(this.getLabelProperties('10em', 'normal', 'middle', attributes.attribute3.toUpperCase()));
        }

        if (attributes.attribute4) {
            attribute4 = attributes.attribute4.toUpperCase() + '\n';
            labels.push(this.getLabelProperties('10em', 'normal', 'middle', attributes.attribute4.toUpperCase()));
        }

        if (attributes.attribute5) {
            attribute5 = attributes.attribute5.toUpperCase();
            labels.push(this.getLabelProperties('10em', 'normal', 'middle', attributes.attribute5.toUpperCase()));
        }

        labelValue = (attribute1 + attribute2 + attribute3 + attribute4 + attribute5).replace(new RegExp('\n$'), '');
        if (labelValue !== '') {
            labelProperties.labels = labels;
            labelProperties.labelExpression = this.formatLabel(labelValue, 10, true);

            return labelProperties;
        } else {
            return null;
        }
    }

    buildOccupationImprovement(attributes: Attributes) {
        const labels = [];
        const labelProperties = {} as labelProperties;

        let attribute1 = '';
        let attribute2 = '';

        if (attributes.attribute1) {
            attribute1 = attributes.attribute1.toString().toUpperCase() + '\n';
            labels.push(this.getLabelProperties('7.2em', 'normal', 'middle', attribute1.trim()));
        }

        if (attributes.attribute2 != null && !isNaN(attributes.attribute2)) {
            attribute2 = this.labelExpressionUtilityService.round(attributes.attribute2, 2).toString();
            labels.push(this.getLabelProperties('7.2em', 'normal', 'middle', attribute2));
        }

        const labelValue = (attribute1 + attribute2).replace(/\n$/, '');

        if (labelValue !== '') {
            labelProperties.labels = labels;
            labelProperties.labelExpression = this.formatLabel(labelValue, 7.2, true);
            return labelProperties;
        } else {
            return null;
        }
    }

    buildDepthLimitAll(attributes: Attributes) {
        let attribute = '';
        const labels = [];
        const labelProperties = {} as labelProperties;

        if (attributes.attributeCustom) {
            attribute = attributes.attributeCustom + '';
            labels.push(this.getLabelProperties('14em', 'normal', 'middle', attribute.toUpperCase()));
        } else {
            if (attributes.attribute1) {
                attribute = attributes.attribute1;
                labels.push(this.getLabelProperties('14em', 'normal', 'middle', attribute));
            }
        }

        if (attribute !== '') {
            labelProperties.labels = labels;
            labelProperties.labelExpression = this.formatLabel(
                this.labelExpressionUtilityService.encodeSpecialCharacters(attribute).toUpperCase(),
                14,
                true
            );

            return labelProperties;
        } else {
            return null;
        }
    }

    buildAbuttalAnnotationLot(attributes: Attributes) {
        let attribute1 = '';
        let attribute2 = '';
        let attribute3 = '';
        const labels = [];
        const labelProperties = {} as labelProperties;
        let labelValue = '';

        if (attributes.attribute1) {
            attribute1 = this.formatLabel(attributes.attribute1, 14, false) + '\n';
            labels.push(this.getLabelProperties('14em', 'italic', 'middle', attributes.attribute1));
        }

        if (attributes.attribute2) {
            attribute2 = attributes.attribute2 + '\n';
            labels.push(this.getLabelProperties('10em', 'normal', 'middle', attributes.attribute2));
        }

        if (attributes.attribute3) {
            attribute3 = '(' + attributes.attribute3 + ')';
            labels.push(this.getLabelProperties('10em', 'normal', 'middle', attribute3));
        }

        labelValue = (attribute2 + attribute3).replace(new RegExp('\n$'), '');
        if (labelValue !== '') {
            labelProperties.labels = labels;
            labelProperties.labelExpression = attribute1 + this.formatLabel(labelValue, 10, true);

            return labelProperties;
        } else {
            labelProperties.labels = labels[0];
            labelProperties.labelExpression = attribute1.replace(new RegExp('\n$'), '');

            return labelProperties;
        }
    }

    buildAbuttalAnnotationRoadsAndHighWays(attributes: Attributes) {
        let attribute1 = '';
        let attribute2 = '';
        let attribute3 = '';
        const labels = [];
        const labelProperties = {} as labelProperties;
        let labelValue = '';

        if (attributes.attribute1) {
            attribute1 = attributes.attribute1.toUpperCase() + '\u00A0\u00A0\u00A0';
        }

        if (attributes.attribute2) {
            attribute2 = attributes.attribute2.toUpperCase() + '\u00A0\u00A0\u00A0';
        }

        if (attributes.attribute3) {
            attribute3 = attributes.attribute3.toUpperCase();
        }

        labelValue = attribute1 + attribute2 + attribute3;
        if (labelValue !== '') {
            labels.push([
                this.getLabelProperties('14em', 'normal', 'middle', attribute1.toUpperCase()),
                this.getLabelProperties('14em', 'normal', 'middle', attribute2.toUpperCase()),
                this.getLabelProperties('14em', 'normal', 'middle', attribute3.toUpperCase())
            ]);

            labelProperties.labels = labels;
            labelProperties.labelExpression = this.formatLabel(labelValue, 14, true);

            return labelProperties;
        } else {
            return null;
        }
    }

    buildAbuttalAnnotationAccessWay(attributes: Attributes) {
        let attribute1 = '';
        let attribute2 = '';
        let attribute3 = '';
        const labels = [];
        const labelProperties = {} as labelProperties;
        let labelValue = '';
        const subType = attributes.featuresubtype;
        const prefix = subType === 8 ? '(' + 'ROW' + ')' : '(' + 'PAW' + ')';

        if (attributes.attribute1) {
            attribute1 = this.formatLabel(attributes.attribute1, 14, false) + '\n';
        }

        if (attributes.attribute2) {
            attribute2 = attributes.attribute2.toUpperCase() + '\n';
        }

        if (attributes.attribute3) {
            attribute3 = attributes.attribute3;
        }

        labelValue = (attribute2 + attribute3).replace(new RegExp('\n$'), '');
        if (labelValue !== '') {
            labels.push(this.getLabelProperties('14em', 'italic', 'middle', attributes.attribute1));
            labels.push(this.getLabelProperties('10em', 'normal', 'middle', prefix));
            if (subType === 8) {
                labels.push(
                    this.getLabelProperties(
                        '10em',
                        'normal',
                        'middle',
                        attributes.attribute2 ? attributes.attribute2.toUpperCase() : attributes.attribute2
                    )
                );
            }

            labels.push(
                this.getLabelProperties('10em', 'normal', 'middle', subType === 8 ? attributes.attribute3.toUpperCase() : attributes.attribute3)
            );

            labelProperties.labels = labels;
            labelProperties.labelExpression = attribute1 + this.formatLabel(prefix + '\n' + labelValue, 10, true);

            return labelProperties;
        } else {
            labels.push(this.getLabelProperties('14em', 'italic', 'middle', attributes.attribute1));
            labelProperties.labels = labels;
            labelProperties.labelExpression = attribute1.replace(new RegExp('\n$'), '');

            return labelProperties;
        }
    }

    buildAbuttalAnnotationReserves(attributes: Attributes) {
        let attribute2 = '';
        let attribute3 = '';
        let attribute4 = '';
        const labels = [];
        const labelProperties = {} as labelProperties;
        let labelValue = '';

        if (attributes.attribute2) {
            const reserveNameOrNumber = parseInt(attributes.attribute2);
            const nameOrNumberlabelValue = !isNaN(reserveNameOrNumber) ? 'RES ' + attributes.attribute2 : attributes.attribute2.toUpperCase();

            attribute2 = this.formatLabel(nameOrNumberlabelValue, 14, true) + '\n';
            labels.push(this.getLabelProperties('14em', 'normal', 'middle', nameOrNumberlabelValue));
        }

        if (attributes.attribute3) {
            attribute3 = this.formatLabel(attributes.attribute3, 14, false) + '\n';
            labels.push(this.getLabelProperties('14em', 'italic', 'middle', attributes.attribute3.toUpperCase()));
        }

        if (attributes.attribute4) {
            attribute4 = this.formatLabel(attributes.attribute4, 10, true);
            labels.push(this.getLabelProperties('10em', 'normal', 'middle', attributes.attribute4));
        }

        labelValue = (attribute2 + attribute3 + attribute4).replace(new RegExp('\n$'), '');
        if (labelValue !== '') {
            labelProperties.labels = labels;
            labelProperties.labelExpression = labelValue;
            return labelProperties;
        } else {
            return null;
        }
    }

    buildAbuttalAnnotationPastralLease(attributes: Attributes) {
        let attribute1 = '';
        let attribute2 = '';
        let attribute3 = '';
        let attribute4 = '';
        const labels = [];
        const labelProperties = {} as labelProperties;
        let labelValue = '';

        if (attributes.attribute1) {
            attribute1 = this.formatLabel(attributes.attribute1.toUpperCase(), 14, true) + '\n';
            labels.push(this.getLabelProperties('14em', 'normal', 'middle', attributes.attribute1.toUpperCase()));
        }

        if (attributes.attribute2) {
            attribute2 = this.formatLabel(attributes.attribute2.toUpperCase(), 14, true) + '\n';
            labels.push(this.getLabelProperties('14em', 'normal', 'middle', attributes.attribute2.toUpperCase()));
        }

        if (attributes.attribute3) {
            attribute3 = this.formatLabel(attributes.attribute3, 14, false) + '\n';
            labels.push(this.getLabelProperties('14em', 'italic', 'middle', attributes.attribute3));
        }

        if (attributes.attribute4) {
            attribute4 = this.formatLabel(attributes.attribute4, 10, true);
            labels.push(this.getLabelProperties('10em', 'normal', 'middle', attributes.attribute4));
        }

        labelValue = (attribute1 + attribute2 + attribute3 + attribute4).replace(new RegExp('\n$'), '');
        if (labelValue !== '') {
            labelProperties.labels = labels;
            labelProperties.labelExpression = labelValue;
            return labelProperties;
        } else {
            return null;
        }
    }

    buildAbuttalAnnotationMiningTenement(attributes: Attributes) {
        let attribute1 = '';
        const labels = [];
        const labelProperties = {} as labelProperties;

        if (attributes.attribute1) {
            const reserveNameOrNumber = parseInt(attributes.attribute1);
            const labelValue = !isNaN(reserveNameOrNumber) ? 'MT ' + attributes.attribute1.toUpperCase() : attributes.attribute1.toUpperCase();

            attribute1 = this.formatLabel(labelValue, 14, true);
            labels.push(this.getLabelProperties('14em', 'normal', 'middle', labelValue));
        }

        if (attribute1 !== '') {
            labelProperties.labels = labels;
            labelProperties.labelExpression = attribute1;
            return labelProperties;
        } else {
            return null;
        }
    }

    buildAbuttalAnnotationStateForest(attributes: Attributes) {
        let attribute1 = '';
        let attribute2 = '';
        let attribute3 = '';
        const labels = [];
        const labelProperties = {} as labelProperties;
        let labelValue = '';

        if (attributes.attribute1) {
            attribute1 = this.formatLabel('SF ' + attributes.attribute1, 10, true) + '\n';
            labels.push(this.getLabelProperties('10em', 'normal', 'middle', 'SF ' + attributes.attribute1));
        }

        if (attributes.attribute2) {
            attribute2 = this.formatLabel(attributes.attribute2, 14, false) + '\n';
            labels.push(this.getLabelProperties('14em', 'italic', 'middle', attributes.attribute2));
        }

        if (attributes.attribute3) {
            attribute3 = this.formatLabel(attributes.attribute3, 10, true) + '\n';
            labels.push(this.getLabelProperties('10em', 'normal', 'middle', attributes.attribute3));
        }

        labelValue = (attribute1 + attribute2 + attribute3).replace(new RegExp('\n$'), '');
        if (labelValue !== '') {
            labelProperties.labels = labels;
            labelProperties.labelExpression = labelValue;
            return labelProperties;
        } else {
            return null;
        }
    }

    buildSingleAbuttalAnnotation14(attributes: Attributes) {
        let attribute1 = '';
        const labels = [];
        const labelProperties = {} as labelProperties;

        if (attributes.attribute1) {
            attribute1 = this.formatLabel(attributes.attribute1.toUpperCase(), 14, true); // check Unnamed Road
            labels.push(this.getLabelProperties('14em', 'normal', 'middle', attributes.attribute1.toUpperCase()));
        }

        if (attribute1 !== '') {
            labelProperties.labels = labels;
            labelProperties.labelExpression = attribute1;
            return labelProperties;
        } else {
            return null;
        }
    }

    buildAbuttalAnnotationWater(attributes: Attributes) {
        let attribute1 = '';
        let attribute2 = '';
        const labels = [];
        const labelProperties = {} as labelProperties;

        if (attributes.attribute1) {
            attribute1 = attributes.attribute1.toUpperCase() + '\u00A0\u00A0\u00A0';
        }

        if (attributes.attribute2) {
            attribute2 = attributes.attribute2.toUpperCase();
        }

        if (attribute1 + attribute2 !== '') {
            labels.push([
                this.getLabelProperties('14em', 'italic', 'middle', attribute1),
                this.getLabelProperties('14em', 'italic', 'middle', attribute2)
            ]);

            labelProperties.labels = labels;
            labelProperties.labelExpression = this.formatLabel((attribute1 + attribute2).toUpperCase(), 14, false);

            return labelProperties;
        } else {
            return null;
        }
    }

    buildSingleAbuttalAnnotation10(attributes: Attributes) {
        let attribute1 = '';
        const labels = [];
        const labelProperties = {} as labelProperties;

        if (attributes.attribute1) {
            attribute1 = this.formatLabel(attributes.attribute1, 10, true);
            labels.push(this.getLabelProperties('10em', 'normal', 'middle', attributes.attribute1));
        }

        if (attribute1 !== '') {
            labelProperties.labels = labels;
            labelProperties.labelExpression = attribute1;

            return labelProperties;
        } else {
            return null;
        }
    }

    buildAbuttalOtherReserve(attributes: Attributes) {
        let attribute1 = '';
        let attribute2 = '';
        let attribute3 = '';
        const labels = [];
        const labelProperties = {} as labelProperties;
        let labelValue = '';

        if (attributes.attribute1) {
            attribute1 = this.formatLabel(attributes.attribute1.toUpperCase(), 14, true) + '\n';
        }

        if (attributes.attribute2) {
            attribute2 = this.formatLabel(attributes.attribute2, 14, false) + '\n';
        }

        if (attributes.attribute3) {
            attribute3 = this.formatLabel(attributes.attribute3.toUpperCase(), 10, true) + '\n';
        }

        if (attribute2 + attribute3 !== '') {
            labels.push(this.getLabelProperties('14em', 'italic', 'middle', attributes.attribute2));
            labels.push(this.getLabelProperties('10em', 'normal', 'middle', attributes.attribute3.toUpperCase()));
            labels.push(this.getLabelProperties('14em', 'normal', 'middle', attributes.attribute1.toUpperCase()));

            labelValue = (attribute2 + attribute3 + attribute1).replace(new RegExp('\n$'), '');
            labelProperties.labels = labels;
            labelProperties.labelExpression = labelValue;

            return labelProperties;
        } else {
            labels.push(this.getLabelProperties('14em', 'normal', 'middle', attributes.attribute1.toUpperCase()));
            labelProperties.labels = labels;
            labelProperties.labelExpression = attribute1.replace(new RegExp('\n$'), '');

            return labelProperties;
        }
    }

    buildDepthLimitOther(attributes: Attributes) {
        let attribute = '';
        const labels = [];
        const labelProperties = {} as labelProperties;
        const labelValues = [];
        const subType = attributes.featuresubtype;

        if (attributes.attributeCustom) {
            attribute = attributes.attributeCustom + '';
            attribute.split(/[\r\n]/g).map(s => {
                labelValues.push(
                    subType === 25
                        ? this.formatLabel(s.toUpperCase().trim(), 10, true) + '\n'
                        : this.formatLabel(s.toUpperCase().trim(), 14, true) + '\n'
                );

                labels.push(
                    subType === 25
                        ? this.getLabelProperties('10em', 'normal', 'middle', s.toUpperCase().trim())
                        : this.getLabelProperties('14em', 'normal', 'middle', s.toUpperCase().trim())
                );
            });
        }

        if (attribute) {
            labelProperties.labels = labels;
            labelProperties.labelExpression = labelValues.join('').replace(new RegExp('\n$'), '');
            return labelProperties;
        } else {
            return null;
        }
    }
}
